// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"b9e1d28a","703":"46ba347a","787":"e897f72d"}[chunkId] + ".chunk.js";
};